<!-- MAP VIEW -->

<div #mapContainer id="map"></div>





<!-- Emloyee List  -->
<div *ngIf="enableEmployeesDetails" class="employee-list-card" [@slideIn] style="z-index:1">
    <app-employee-list [stopDetail]="employeesDetailsWithShuttleStops" (closePopup)="onClosePopup($event)">
    </app-employee-list>
</div>

<!--  Actions on Map -->
<div class="actions-card d-flex flex-dir-col" style="background:white;min-width: calc(100vw - 640px);">

    <div class="d-flex flex-dir-row just-space" style="padding: 12px 16px;height:24px;cursor: pointer;"
        (click)="actionsOpen=!actionsOpen">
        <span class="action-text text-bold">Actions</span>
        <img *ngIf="!actionsOpen" src="{{imgSrc}}assets/icons/line-down-arrow.svg" style="padding:0px ;" />
        <img *ngIf="actionsOpen" src="{{imgSrc}}assets/icons/line-arrow-up.svg" style="padding:0px ;" />
    </div>
    <div *ngIf="actionsOpen" class="d-flex align-center" style="margin: 0 16px;border-top: 1px solid lightgray;">
        <div class="action-dropdown d-flex gap-12">
            <!-- <mis-multi-select-dropdown [enableSelectAll]="true" [hideApplyButton]="false" [searchEnabled]="false"
                [selectedItems]="selectedActions" label="Driver Actions" width="180px" [noDataMessage]="'no data'"
                [data]="actions" [options]="{ sortLabels: false }" [showSelectedCount]="true"
                (onChange)="selectedItems($event)">
            </mis-multi-select-dropdown> -->

            <div class="selection-buttons d-flex flex-dir-col">
                <span class="h-12" style="margin-bottom: 8px;color:#6A737D;margin-top: 5px;">Driver Actions</span>
                <div class="d-flex flex-dir-row gap-12">
                    <div (click)="noShowAction?unselectedValue('No Show'):selectedValue('No Show')"
                        [ngClass]="{'noshow-status':noShowAction===true}"
                        class="btn d-flex align-center gap-8 pointer-cursor unselected-btn btn just-center w-140">
                        <img *ngIf="!noShowAction" src="{{imgSrc}}assets/icons/no-show-grey.svg" style="padding:0" />
                        <img *ngIf="noShowAction" src="{{imgSrc}}assets/icons/no-show1.svg" style="padding:0" />
                        <span class="h7">No Show</span>
                    </div>
                    <div (click)="callEmployeeAction?unselectedValue('Call Employee'):selectedValue('Call Employee')"
                        [ngClass]="{'call-employee':callEmployeeAction===true}"
                        class="btn d-flex align-center gap-8 pointer-cursor unselected-btn btn just-center w-140">
                        <img *ngIf="!callEmployeeAction" src="{{imgSrc}}assets/icons/call1.svg" style="padding:0" />
                        <img *ngIf="callEmployeeAction" src="{{imgSrc}}assets/icons/call-active.svg"
                            style="padding:0" />
                        <span class="h7">Call Employee</span>
                    </div>
                    <div (click)="vehicleArrivedAction?unselectedValue('Vehicle Arrived'):selectedValue('Vehicle Arrived')"
                        [ngClass]="{'vehicle-arrived':vehicleArrivedAction===true}"
                        class="btn d-flex align-center gap-8 pointer-cursor unselected-btn btn just-center w-140">

                        <img *ngIf="!vehicleArrivedAction" src="{{imgSrc}}assets/icons/vehicle-arrived1.svg"
                            style="padding:0" />
                        <img *ngIf="vehicleArrivedAction" src="{{imgSrc}}assets/icons/vehicle-arrived.svg"
                            style="padding:0" />
                        <span class="h7">Vehicle Arrived</span>
                    </div>
                </div>


            </div>
            <!-- <div>
                <div (click)="toggleSelectedButtons('notBoarded')" class="btn d-flex align-center gap-8 pointer-cursor"
                  [ngClass]="{'selected-btn-not-boarded':selectedNotBoarded==true,'unselected-btn':selectedNotBoarded==false,'disable':notBoarded===0}">
                  <span *ngIf="selectedNotBoarded" class="icon-ic-ui-check-24"></span>
                  <span class="h7">Driver App</span>
                </div>
                <div (click)="toggleSelectedButtons('notBoarded')" class="btn d-flex align-center gap-8 pointer-cursor"
                  [ngClass]="{'selected-btn-not-boarded':selectedNotBoarded==true,'unselected-btn':selectedNotBoarded==false,'disable':notBoarded===0}">
                  <span *ngIf="selectedNotBoarded" class="icon-ic-ui-check-24"></span>
                  <span class="h7">Fixed Device</span>
                </div>
              </div> -->
            <img src="{{imgSrc}}assets/icons/Line.svg" alt="">
            <div class="child-2 d-flex flex-dir-col">
                <span class="h-12" style="margin-bottom: 8px;color:#6A737D;margin-top: 5px;">Vehicle tracking
                    from</span>
                <div class="d-flex align-center gap-16">
                    <div class="d-flex gap-8">
                        <!-- <mis-radio [id]=1 name="radio" [value]="'MOBILE'" (valueChange)="radioSelect('MOBILE')"
                            ngDefaultControl [formControl]="formControlValue"></mis-radio>
                        <span class="h7">Mobile</span> -->
                        <div (click)="!driverFixedDevice?'':selectedValue('Driver App')"
                            [ngClass]="{'driverFixed-selected':driverFixedDevice===false,'disabled-state' : !checkDriverDeviceAvailability()}"
                            class="btn d-flex align-center gap-8 pointer-cursor unselected-btn btn just-center w-140">

                            <img *ngIf="!driverFixedDevice" src="{{imgSrc}}assets/icons/tick-active.svg"
                                style="padding:0" />
                            <span class="h7">Driver App</span>
                        </div>
                    </div>
                    <div class="d-flex gap-8">
                        <!-- <mis-radio [id]=2 name="radio" [value]="'fixed device'" (valueChange)="radioSelect('FIXED_DEVICE')"
                            ngDefaultControl [formControl]="formControlValue"></mis-radio>
                        <span class="h7">Fixed Device</span> -->
                        <div (click)="driverFixedDevice?'':selectedValue('Fixed Device')"
                            [ngClass]="{'driverFixed-selected':driverFixedDevice===true, 'disabled-state' : !checkFixedDeviceAvailability()}"
                            class="btn d-flex align-center gap-8 pointer-cursor unselected-btn btn just-center w-140">

                            <img *ngIf="driverFixedDevice" src="{{imgSrc}}assets/icons/tick-active.svg"
                                style="padding:0" />
                            <span class="h7">Fixed Device</span>
                        </div>
                    </div>

                </div>

            </div>




        </div>
    </div>
    <div *ngIf="actionsOpen" class="actions-card1 d-flex align-center">
        <div class="child-1 d-flex flex-dir-col">

            <div class="d-flex gap-12 align-center">
                <span class="h7">Planned Route</span>
                <mis-switch style="zoom:0.7" (change)="showPlannedRoute()" [checked]="plannedRouteToggle"></mis-switch>
            </div>
        </div>
        <img src="{{imgSrc}}assets/icons/Line.svg" alt="">
        <div class="child-1 d-flex flex-dir-col">

            <div class="d-flex gap-12 align-center">
                <span class="h7">Sign In Locations</span>
                <mis-switch style="zoom:0.7" (change)="showSignInLocationToggler()"
                    [checked]="signInLocationCheck"></mis-switch>
            </div>
        </div>
        <img src="{{imgSrc}}assets/icons/Line.svg" alt="">
        <div class="child-1 d-flex flex-dir-col">

            <div class="d-flex gap-12 align-center">
                <span class="h7">Traffic</span>
                <mis-switch style="zoom:0.7" (change)="enableTafficToggler()" [checked]="enableTraffic"></mis-switch>
            </div>
        </div>
        <img src="{{imgSrc}}assets/icons/Line.svg" alt="">
        <div class="child-1 d-flex flex-dir-col">

            <div class="d-flex gap-12 align-center">
                <span class="h7">Speed</span>
                <mis-switch style="zoom:0.7" (change)="enableSpeedPolyline()" [checked]="enableSpeed"></mis-switch>
            </div>
        </div>

    </div>


    <div *ngIf="actionsOpen" class="actions-card1 d-flex align-center">
        <div class="child-1 d-flex flex-dir-col">

            <div class="d-flex gap-12 align-center">
                <span class="h7">Geofences</span>
                <mis-switch style="zoom:0.7" (change)="showGeofences()" [checked]="geofenceToggle"></mis-switch>
            </div>
        </div>
        <img src="{{imgSrc}}assets/icons/Line.svg" alt="">
        <div class="child-1 d-flex flex-dir-col">
            <div class="d-flex gap-12 align-center">
                <span class="h7">Virtual Waypoints</span>
                <mis-switch style="zoom:0.7" (change)="showVirtualWaypoints()" [checked]="virtualWayPointToggle"></mis-switch>
            </div>
        </div>
        </div>


</div>



<!-- LOCATION CARD -->
<!-- <div [ngStyle]="{'background-color':speedColor}" class="location-status-card d-flex flex-dir-col just-space">
    <div><span class="h7">Last Location:</span><span class="h7"> {{ lastLocationUpdate }}</span></div>
    <div>
        <span class="h7">Speed: </span><span class="h7"> {{ speedOnCard}} km/hr</span>
    </div>
   
</div> -->
<div class="p-a-chart">
    <img src="{{imgSrc}}assets/icons/planned-actual.svg" />
</div>

<figure id="highCharts" [ngStyle]="{'background-color':speedColor}"
    class="highcharts-figure location-status-card d-flex flex-dir-col just-space">
    <div id="container"></div>
</figure>

<div class="legacy-trip-view-toggle" [ngStyle]="{
    'bottom': actionsOpen ? '210px' : '78px'
}">

<app-tab-filter [defaultWidth]="65" [tabs]="tabs" (selectedTab)="handleSelectedTab($event)" [defaultTab]="defaultTab"></app-tab-filter>

</div>